import Button from './src/button'

export default Button


// WEBPACK FOOTER //
// ./src/components/tofu-button/index.js